import { observer } from "mobx-react-lite";
import { FunctionComponent } from "react";

import {
  FontWeights,
  IconButton,
  IContextualMenuItem,
  mergeStyles,
  Stack,
  Text,
  TooltipHost,
  useTheme
} from "@bps/fluent-ui";
import { PatientNotice } from "@stores/practice/models/PatientNotice.ts";
import { PatientNoticeTypeText } from "@ui-components/RefText.tsx";

import { colorDotPrefixStyles, getPriorityColor } from "./utils.ts";

interface SidePatientNoticesTableRowProps {
  showActions: undefined | boolean;
  items: IContextualMenuItem[];
  patientNotice: PatientNotice;
}

export const SidePatientNoticesTableRow: FunctionComponent<SidePatientNoticesTableRowProps> =
  observer(({ showActions, items, patientNotice }) => {
    const { palette } = useTheme();

    return (
      <Stack
        horizontal
        verticalAlign="center"
        tokens={{ childrenGap: 4 }}
        styles={{
          root: {
            width: "100%",
            position: "relative" // Fix for issue where tooltip hover causes scrollbar
          }
        }}
      >
        <Stack
          styles={{
            root: {
              width: "100%",
              marginRight: "auto",
              color: palette.themeDarker,
              fontWeight: FontWeights.semibold
            }
          }}
        >
          <Stack
            horizontal
            horizontalAlign="space-between"
            styles={{ root: { width: "100%" } }}
          >
            <Stack horizontal tokens={{ childrenGap: 8 }}>
              <div
                className={mergeStyles(
                  colorDotPrefixStyles(
                    getPriorityColor(palette, patientNotice.priority)
                  )
                )}
              />

              <span>
                <PatientNoticeTypeText
                  code={patientNotice.type}
                  separator=" "
                />
              </span>
            </Stack>
            {showActions && (
              <TooltipHost content="More">
                <IconButton
                  menuIconProps={{ iconName: "More" }}
                  menuProps={{ items }}
                  styles={{ root: { width: 18, height: 18 } }}
                />
              </TooltipHost>
            )}
          </Stack>

          <Text
            styles={{
              root: {
                wordBreak: "break-word",
                marginLeft: "18px"
              }
            }}
          >
            {patientNotice.comment && ` ${patientNotice.comment}`}
          </Text>
        </Stack>
      </Stack>
    );
  });
